module.exports = __webpack_public_path__ + "static/media/22-008.77a139c2.png";